// assets/olaplex-buybox.js
// Buy-box enhancements shared by the product page and the collection
// quick-add popup:
//   1. Move the quantity field into .product-form__buttons and grid it with
//      the Add to cart button (Buy-with-Shop spans full width beneath) — see
//      assets/olaplex-buybox.css (.ola-buybox-grid).
//   2. Mirror the current variant price into the Add to cart button.
// Re-applies on load, on product-info:loaded, and after any variant change
// (with a few retries so it catches Dawn's async price update).
(function () {
  if (window.__olaBuyboxInit) return;
  window.__olaBuyboxInit = true;

  function currentPrice(container) {
    var root = container.querySelector('[id^="price-"] .price') || container.querySelector('.price');
    if (!root) return '';
    var onSale = root.classList.contains('price--on-sale');
    var el = onSale
      ? root.querySelector('.price-item--sale')
      : root.querySelector('.price-item--regular');
    return el ? el.textContent.trim() : '';
  }

  function apply(root) {
    (root || document).querySelectorAll('.product__info-container').forEach(function (container) {
      var btns = container.querySelector('.product-form__buttons');
      if (!btns) return;

      var qty = container.querySelector('.product-form__quantity');
      if (qty && qty.parentElement !== btns) {
        btns.insertBefore(qty, btns.firstChild);
      }
      btns.classList.add('ola-buybox-grid');

      var submit = btns.querySelector('.product-form__submit');
      if (submit) {
        var span = submit.querySelector('.ola-atc-price');
        if (!span) {
          span = document.createElement('span');
          span.className = 'ola-atc-price';
          span.setAttribute('aria-hidden', 'true');
          submit.appendChild(span);
        }
        var price = currentPrice(container);
        if (price && span.textContent !== price) span.textContent = price;
      }

      // Move the "Pay over time" installment line under the buy buttons
      // (i.e. beneath the Shop Pay button), before "View full details".
      var buyWrap = btns.closest('.ola-buy-buttons-block');
      var installment = container.querySelector('.ola-installment-block');
      if (buyWrap && installment && buyWrap.nextElementSibling !== installment) {
        buyWrap.insertAdjacentElement('afterend', installment);
      }
    });
  }

  function reapply() { apply(document); }
  function scheduleReapply() { [120, 400, 800, 1400].forEach(function (d) { setTimeout(reapply, d); }); }

  function init() { apply(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', reapply);
  document.addEventListener('product-info:loaded', function (e) { apply(e.target || document); scheduleReapply(); });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-selects, .product__info-container')) scheduleReapply();
  }, true);
})();
